import { DemoStepWidget, DemoWidgetType } from '../demoStepWidget';

export class WidgetDemoPlayerCounter implements DemoStepWidget {
  type = DemoWidgetType.QUIZ_PLAYER_COUNTER;
}
